export default __webpack_public_path__ + "static/media/building.85b01e0c.svg";